/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingConfig } from '../../config/loading.config';
import { headerConfig } from '../../config/header.config';
import { errorConfig } from '../../config/error.config';
import { notificationConfig } from '../../config/notifications.config';
import { paymentSummaryConfig } from '../../config/paymentSummary.config';
export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      loading: loadingConfig,
      header: headerConfig,
      error: errorConfig,
      notifications: notificationConfig,
      paymentSummaryConfig: paymentSummaryConfig,
    };
  }
}
